module.exports = __webpack_public_path__ + "media/images/lb/230-6e7b814d4b176070c9ef751212f5f332.svg";